function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.16,
  height: 12.32,
  y: 0.56,
  stroke: "#BFBBB7",
  strokeWidth: 0.84,
  rx: 1.68
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BFBBB7",
  d: "M2.768 2.828c0-.08.024-.138.072-.174.048-.036.132-.054.252-.054h1.176c.544 0 .984.114 1.32.342.336.228.59.616.762 1.164.172.548.258 1.302.258 2.262 0 1.152-.09 2.066-.27 2.742-.18.676-.442 1.16-.786 1.452-.344.292-.772.438-1.284.438h-1.5V2.828zm1.524 7.248c.24 0 .448-.094.624-.282.176-.188.32-.56.432-1.116.112-.556.168-1.358.168-2.406 0-.728-.044-1.294-.132-1.698-.088-.404-.22-.686-.396-.846-.176-.16-.408-.24-.696-.24H3.74v6.588h.552zm6.576 1.044c-.544 0-.97-.126-1.278-.378-.308-.252-.534-.692-.678-1.32-.144-.628-.216-1.518-.216-2.67 0-1.056.082-1.896.246-2.52.164-.624.414-1.072.75-1.344S10.464 2.48 11 2.48c.528 0 .944.13 1.248.39.304.26.526.694.666 1.302.14.608.21 1.456.21 2.544 0 1.096-.078 1.964-.234 2.604-.156.64-.398 1.1-.726 1.38-.328.28-.76.42-1.296.42zm.036-.996a.822.822 0 0 0 .696-.336c.168-.224.29-.58.366-1.068.076-.488.114-1.148.114-1.98 0-.832-.032-1.48-.096-1.944-.064-.464-.176-.8-.336-1.008-.16-.208-.384-.312-.672-.312a.82.82 0 0 0-.69.342c-.172.228-.298.596-.378 1.104-.08.508-.12 1.198-.12 2.07 0 .768.034 1.378.102 1.83.068.452.182.782.342.99.16.208.384.312.672.312zM18.908 2.6v.708c0 .08-.016.134-.048.162-.032.028-.084.042-.156.042h-1.476v7.296c0 .072-.016.12-.048.144-.032.024-.128.038-.288.042-.16.004-.372.006-.636.006V3.512h-1.632v-.72c0-.128.068-.192.204-.192h4.08z"
}));

var SvgUsdot = function SvgUsdot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsdot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usdot.44ba32ac.svg";
export { ForwardRef as ReactComponent };